import { IsNameValid } from "@unauthenticated/shared/components/NameValidation/NameValidation";

import type { SimplifySignUpFormData } from "../types";

export const isFormValid = (formData: SimplifySignUpFormData) => {
  const isNameValid = IsNameValid(formData.firstName) && IsNameValid(formData.lastName);
  const isPractitionerTypeValid = formData.practitionerType !== null;
  const isToSChecked = formData.tosTimestamp !== "";

  // If name is valid, dispensary name length can be 0 because it will be auto-generated but if manually entered it must be at least 4 characters.
  const isDispensaryNameValid =
    formData.dispensaryName.length > 3 || formData.dispensaryName.length === 0;

  return isNameValid && isPractitionerTypeValid && isToSChecked && isDispensaryNameValid;
};
